export const AUTH_MODES = {
  ALFA_ID: 'alfa_id',
  PHONE_TOTP_ONLY: 'phone_totp_only',
} as const;

export type AuthMode = (typeof AUTH_MODES)[keyof typeof AUTH_MODES];
